import { Map } from 'immutable';
import { createSelector } from 'reselect';
import { STATE_NAME } from './constants';

export const getStateSlice = state => state.get(STATE_NAME);

export const getMarket = state => getStateSlice(state).get('market') || Map({});

export const getMarketName = createSelector(
  getMarket,
  market => market.get('market')
);

export const getAvailableLanguages = state =>
  getMarket(state).get('ifoodPPSILanguageCodes');

export const getLanguage = state => getStateSlice(state).get('language');

export const getIsDataDirty = state => getStateSlice(state).get('isDataDirty');

export const getConfigs = state => getStateSlice(state).get('configs');

export const getMarketDisplayName = state =>
  getStateSlice(state).get('displayMarketName');

export const getMarketFetching = state =>
  getStateSlice(state).get('isFetchingName');

export const getFetchNameError = state =>
  getStateSlice(state).get('fetchingNameError');

// adding to check market config API call
export const getMarketConfig = state =>
  getStateSlice(state).get('marketConfigs');
export const fetchingMarketConfig = state =>
  getStateSlice(state).get('isFetchingMarketConfigs');
export const marketConfigFetchError = state =>
  getStateSlice(state).get('fetchMarketConfigError');
export const getReviewMarket = state =>
  getStateSlice(state).get('reviewMarket');
export const getMarketLanguage = state =>
  getStateSlice(state).get('reviewMarketLanguage');
export const getMarketAvailableLangauge = state =>
  getStateSlice(state).get('reviewMarketAvailableLanguage');

export const getIsFetchingConfigs = state =>
  getStateSlice(state).get('isFetchingConfigs');

export const getFetchConfigsError = state =>
  getStateSlice(state).get('fetchConfigError');

export const getIsFetchingGlobalConfigs = state =>
  getStateSlice(state).get('isFetchingGlobalConfigs');

export const getFetchGlobalConfigsError = state =>
  getStateSlice(state).get('fetchGlobalConfigError');

export const getViewsVisited = state =>
  getStateSlice(state).get('viewsVisited');

export const getCallback = state => getStateSlice(state).get('callback');

export const getIsViewVisited = view =>
  createSelector(
    getViewsVisited,
    viewsVisited => viewsVisited.has(view)
  );
